import {Button, Dropdown, Empty, Skeleton} from "antd";
import type {MenuProps} from "antd";
import {motion, useReducedMotion} from "framer-motion";
import "./style.less"
import AddActionButton from "../../../../components/action-buttons/addAction-button/AddActionButton";
import {useAuth} from "../../../../context/authContext";
import StatisticModal from "../../../../components/modals/statistic-modal/StatisticModal";
import {useStatisticController} from "../../../../controllers/statistic-controller";
import {DeleteOutlined, EditOutlined, MoreOutlined} from "@ant-design/icons";
import {StatisticItem} from "../../../../types/statistic";

const StatisticList = () => {
  const {canManageContent} = useAuth()
  const statisticController = useStatisticController()
  const shouldReduceMotion = useReducedMotion()
  const {statisticItemsList, isLoading} = statisticController

  const getAdminMenu = (item: StatisticItem): MenuProps["items"] => [
    {
      key: "edit",
      icon: <EditOutlined/>,
      label: "Редагувати",
      onClick: () => statisticController.editButtonHandler(item),
    },
    {
      key: "delete",
      danger: true,
      icon: <DeleteOutlined/>,
      label: "Видалити",
      onClick: () => statisticController.confirmDelete({id: item.$id || ""}),
    },
  ]

  return <section className="home-statistics" aria-labelledby="statistics-title">
    <div className="home-statistics__inner">
      <header className="home-statistics__header">
        <div className="home-section-heading home-section-heading--centered">
          <div className="home-section-heading__eyebrow">Лікарня у цифрах</div>
          <h2 className="home-section-heading__title" id="statistics-title">Працюємо для вашого здоров’я</h2>
          <p className="home-section-heading__description">
            Ключові показники, за якими стоїть щоденна робота нашої команди.
          </p>
        </div>
        {canManageContent && <div className="home-statistics__add">
          <AddActionButton onClick={statisticController.toggleModal}/>
        </div>}
      </header>

      {isLoading && statisticItemsList.length === 0
        ? <div className="statistics-grid statistics-grid--loading" aria-label="Завантаження статистики">
          {[0, 1, 2, 3].map((item) => <div className="statistic-skeleton" key={item}>
            <Skeleton active paragraph={{rows: 2}} title={{width: "55%"}}/>
          </div>)}
        </div>
        : statisticItemsList.length === 0
          ? <div className="home-statistics__empty"><Empty description="Статистичні дані ще не додано"/></div>
          : <div className={`statistics-grid ${isLoading ? "statistics-grid--updating" : ""}`}>
            {statisticItemsList.map((item, index) => <motion.article
              className="statistic-card"
              key={item.$id || `${item.title}-${index}`}
              initial={shouldReduceMotion ? false : {opacity: 0, y: 22}}
              whileInView={shouldReduceMotion ? undefined : {opacity: 1, y: 0}}
              viewport={{once: true, amount: 0.25}}
              transition={{duration: 0.4, delay: Math.min(index * 0.08, 0.32)}}
            >
              <div className="statistic-card__index" aria-hidden="true">{String(index + 1).padStart(2, "0")}</div>
              <div className="statistic-card__value">{item.value}</div>
              <h3 className="statistic-card__title">{item.title}</h3>
              {item.description && <p className="statistic-card__description">{item.description}</p>}
              <div className="statistic-card__accent" aria-hidden="true"/>

              {canManageContent && <Dropdown menu={{items: getAdminMenu(item)}} trigger={["click"]}>
                <Button
                  className="statistic-card__admin"
                  type="text"
                  shape="circle"
                  icon={<MoreOutlined/>}
                  aria-label={`Керування показником: ${item.title}`}
                />
              </Dropdown>}
            </motion.article>)}
          </div>}

      {statisticController.isModalOpen && <StatisticModal statisticController={statisticController}/>}
    </div>
  </section>
}

export default StatisticList
